v-container
  v-row
    v-col(cols="12")
      v-form(ref="formRef" v-model="valid" @submit.prevent="onSubmit")
        v-card
          v-card-text
            //- Title
            v-row
              v-col(cols="12")
                h2.text-h4.mb-4(v-html="$t('title')")

            //- What Causes Need
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('causes.heading')")
                p.text-body-1.mb-3(v-html="$t('causes.text')")

            v-divider.my-4

            //- How Performed
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('howPerformed.heading')")
                p.text-body-1.mb-3(v-html="$t('howPerformed.text1')")
                p.text-body-1.mb-3(v-html="$t('howPerformed.text2')")

            v-divider.my-4

            //- Major Risks
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('risks.heading')")
                p.text-body-1.mb-3(v-html="$t('risks.text')")
                ol.mb-4
                  li(v-for="(item, i) in $tm('risks.items')" :key="i" v-html="item")

            v-divider.my-4

            //- Alternatives
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('alternatives.heading')")
                p.text-body-1.mb-3(v-html="$t('alternatives.text')")

            v-divider.my-4

            //- Consent for Treatment
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('surgery.heading')")
                p.text-body-1.mb-3(v-html="$t('surgery.text')")
            v-row
              v-col(cols="4" md="4")
                v-select(
                  v-model="form.verticalSide"
                  :label="'eyelid'"
                  :items="form._attributes.verticalSide.options.parse.args"
                  :rules="[form.validCheck('verticalSide')]"
                )
              v-col(cols="4" md="4")= $t('surgery.eyelidOfMy')
              v-col(cols="4" md="4")
                v-select(
                  v-model="form.side"
                  :label="$t('surgery.eyeSide')"
                  :items="form._attributes.side.options.parse.args"
                  :rules="[form.validCheck('side')]"
                )

            v-divider.my-6

            //- Signature Section
            v-row
              v-col(cols="12")
                NameDateSignature(
                  v-model:name="form.name"
                  v-model:date="form.date"
                  v-model:signature="form.signature"
                  :name_rules="[form.validCheck('name')]"
                  :date_rules="[form.validCheck('date')]"
                  :signature_rules="[form.validCheck('signature')]"
                )

          v-card-actions.d-flex.justify-end
            if error
              .error.text-red-lighten-1 {{ error }}
            v-btn(color="primary" type="submit" :loading="loading") {{ $t('common.submit') }}
